module.exports = __webpack_public_path__ + "static/hero-3-e918ea001fc4ce033f1e165ac5455f1c.png";